// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_table__HhXVU {
  width: 100%;
  padding: 20px;
}

.Table_rootHeaderStyle__wWccl {
  border-radius: 8px;
  background-color: var(--white-color);
  padding: 30px 40px;
  box-shadow: 0px 5px 25px #0000000d;
}
.Table_tableHeaderStyle__GDmpI {
  /* border-radius: 6px; */
  width: 100%;
}
.Table_tableHeader__syFWT {
  padding-bottom: 20px;
  border-bottom: 2px solid #0000001a;
}
.Table_border_radius__gZWKC {
  border-radius: 6px;
}
.Table_headings__WKvJI {
  color: var(--primary-color);
}
.Table_highlightRow__-TXBw {
  border: 2px solid var(--secondary-color);
}

.Table_noData__6HkUe {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

.Table_customTableCss__BaSI6 {
  width: 100%;
}

.Table_customTableCss__BaSI6 tr td {
  width: 100%;
  padding-block: 30px;
}
.Table_customTableCss__BaSI6 tr td h2 {
  font-size: 1rem !important;
}
.Table_tableBody__kc9bZ {
  height: calc(100vh - 370px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.Table_tableBody__kc9bZ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.Table_tableBody__kc9bZ::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.Table_tableBody__kc9bZ::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.Table_tableBody__kc9bZ::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.Table_borderBottom__7xcsb {
  border-bottom: 2px solid #0000001a;
}
`, "",{"version":3,"sources":["webpack://./src/Components/organisms/Table/Table.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC","sourcesContent":[".table {\n  width: 100%;\n  padding: 20px;\n}\n\n.rootHeaderStyle {\n  border-radius: 8px;\n  background-color: var(--white-color);\n  padding: 30px 40px;\n  box-shadow: 0px 5px 25px #0000000d;\n}\n.tableHeaderStyle {\n  /* border-radius: 6px; */\n  width: 100%;\n}\n.tableHeader {\n  padding-bottom: 20px;\n  border-bottom: 2px solid #0000001a;\n}\n.border_radius {\n  border-radius: 6px;\n}\n.headings {\n  color: var(--primary-color);\n}\n.highlightRow {\n  border: 2px solid var(--secondary-color);\n}\n\n.noData {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n}\n\n.customTableCss {\n  width: 100%;\n}\n\n.customTableCss tr td {\n  width: 100%;\n  padding-block: 30px;\n}\n.customTableCss tr td h2 {\n  font-size: 1rem !important;\n}\n.tableBody {\n  height: calc(100vh - 370px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n.tableBody::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.tableBody::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 10px;\n}\n.tableBody::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n}\n.tableBody::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n.borderBottom {\n  border-bottom: 2px solid #0000001a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `Table_table__HhXVU`,
	"rootHeaderStyle": `Table_rootHeaderStyle__wWccl`,
	"tableHeaderStyle": `Table_tableHeaderStyle__GDmpI`,
	"tableHeader": `Table_tableHeader__syFWT`,
	"border_radius": `Table_border_radius__gZWKC`,
	"headings": `Table_headings__WKvJI`,
	"highlightRow": `Table_highlightRow__-TXBw`,
	"noData": `Table_noData__6HkUe`,
	"customTableCss": `Table_customTableCss__BaSI6`,
	"tableBody": `Table_tableBody__kc9bZ`,
	"borderBottom": `Table_borderBottom__7xcsb`
};
export default ___CSS_LOADER_EXPORT___;
